"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
exports.default = (props) => (React.createElement("div", { className: "SelectBox" },
    React.createElement("select", { className: 'SelectBox-options ' + (props.className || ''), onChange: props.onChange, value: props.value || '', id: props.id, name: props.name },
        React.createElement("option", { value: "" }),
        React.createElement("option", { value: "United States" }, "United States"),
        React.createElement("option", { value: "Canada" }, "Canada"),
        React.createElement("option", { value: "", disabled: true }, "-------------"),
        React.createElement("option", { value: "Afghanistan" }, "Afghanistan"),
        React.createElement("option", { value: "Aland Islands" }, "Aland Islands"),
        React.createElement("option", { value: "Albania" }, "Albania"),
        React.createElement("option", { value: "Algeria" }, "Algeria"),
        React.createElement("option", { value: "American Samoa" }, "American Samoa"),
        React.createElement("option", { value: "Andorra" }, "Andorra"),
        React.createElement("option", { value: "Angola" }, "Angola"),
        React.createElement("option", { value: "Anguilla" }, "Anguilla"),
        React.createElement("option", { value: "Antarctica" }, "Antarctica"),
        React.createElement("option", { value: "Antigua And Barbuda" }, "Antigua And Barbuda"),
        React.createElement("option", { value: "Argentina" }, "Argentina"),
        React.createElement("option", { value: "Armenia" }, "Armenia"),
        React.createElement("option", { value: "Aruba" }, "Aruba"),
        React.createElement("option", { value: "Australia" }, "Australia"),
        React.createElement("option", { value: "Austria" }, "Austria"),
        React.createElement("option", { value: "Azerbaijan" }, "Azerbaijan"),
        React.createElement("option", { value: "Bahamas" }, "Bahamas"),
        React.createElement("option", { value: "Bahrain" }, "Bahrain"),
        React.createElement("option", { value: "Bangladesh" }, "Bangladesh"),
        React.createElement("option", { value: "Barbados" }, "Barbados"),
        React.createElement("option", { value: "Belarus" }, "Belarus"),
        React.createElement("option", { value: "Belgium" }, "Belgium"),
        React.createElement("option", { value: "Belize" }, "Belize"),
        React.createElement("option", { value: "Benin" }, "Benin"),
        React.createElement("option", { value: "Bermuda" }, "Bermuda"),
        React.createElement("option", { value: "Bhutan" }, "Bhutan"),
        React.createElement("option", { value: "Bolivia" }, "Bolivia"),
        React.createElement("option", { value: "Bosnia and Herzegowina" }, "Bosnia and Herzegowina"),
        React.createElement("option", { value: "Botswana" }, "Botswana"),
        React.createElement("option", { value: "Bouvet Island" }, "Bouvet Island"),
        React.createElement("option", { value: "Brazil" }, "Brazil"),
        React.createElement("option", { value: "British Indian Ocean Territory" }, "British Indian Ocean Territory"),
        React.createElement("option", { value: "Brunei Darussalam" }, "Brunei Darussalam"),
        React.createElement("option", { value: "Bulgaria" }, "Bulgaria"),
        React.createElement("option", { value: "Burkina Faso" }, "Burkina Faso"),
        React.createElement("option", { value: "Burundi" }, "Burundi"),
        React.createElement("option", { value: "Cambodia" }, "Cambodia"),
        React.createElement("option", { value: "Cameroon" }, "Cameroon"),
        React.createElement("option", { value: "Canada" }, "Canada"),
        React.createElement("option", { value: "Cape Verde" }, "Cape Verde"),
        React.createElement("option", { value: "Cayman Islands" }, "Cayman Islands"),
        React.createElement("option", { value: "Central African Republic" }, "Central African Republic"),
        React.createElement("option", { value: "Chad" }, "Chad"),
        React.createElement("option", { value: "Chile" }, "Chile"),
        React.createElement("option", { value: "China" }, "China"),
        React.createElement("option", { value: "Christmas Island" }, "Christmas Island"),
        React.createElement("option", { value: "Cocos (Keeling) Islands" }, "Cocos (Keeling) Islands"),
        React.createElement("option", { value: "Colombia" }, "Colombia"),
        React.createElement("option", { value: "Comoros" }, "Comoros"),
        React.createElement("option", { value: "Congo" }, "Congo"),
        React.createElement("option", { value: "Congo, the Democratic Republic of the" }, "Congo, the Democratic Republic of the"),
        React.createElement("option", { value: "Cook Islands" }, "Cook Islands"),
        React.createElement("option", { value: "Costa Rica" }, "Costa Rica"),
        React.createElement("option", { value: "Cote d'Ivoire" }, "Cote d'Ivoire"),
        React.createElement("option", { value: "Croatia" }, "Croatia"),
        React.createElement("option", { value: "Cuba" }, "Cuba"),
        React.createElement("option", { value: "Cyprus" }, "Cyprus"),
        React.createElement("option", { value: "Czech Republic" }, "Czech Republic"),
        React.createElement("option", { value: "Denmark" }, "Denmark"),
        React.createElement("option", { value: "Djibouti" }, "Djibouti"),
        React.createElement("option", { value: "Dominica" }, "Dominica"),
        React.createElement("option", { value: "Dominican Republic" }, "Dominican Republic"),
        React.createElement("option", { value: "Ecuador" }, "Ecuador"),
        React.createElement("option", { value: "Egypt" }, "Egypt"),
        React.createElement("option", { value: "El Salvador" }, "El Salvador"),
        React.createElement("option", { value: "Equatorial Guinea" }, "Equatorial Guinea"),
        React.createElement("option", { value: "Eritrea" }, "Eritrea"),
        React.createElement("option", { value: "Estonia" }, "Estonia"),
        React.createElement("option", { value: "Ethiopia" }, "Ethiopia"),
        React.createElement("option", { value: "Falkland Islands (Malvinas)" }, "Falkland Islands (Malvinas)"),
        React.createElement("option", { value: "Faroe Islands" }, "Faroe Islands"),
        React.createElement("option", { value: "Fiji" }, "Fiji"),
        React.createElement("option", { value: "Finland" }, "Finland"),
        React.createElement("option", { value: "France" }, "France"),
        React.createElement("option", { value: "French Guiana" }, "French Guiana"),
        React.createElement("option", { value: "French Polynesia" }, "French Polynesia"),
        React.createElement("option", { value: "French Southern Territories" }, "French Southern Territories"),
        React.createElement("option", { value: "Gabon" }, "Gabon"),
        React.createElement("option", { value: "Gambia" }, "Gambia"),
        React.createElement("option", { value: "Georgia" }, "Georgia"),
        React.createElement("option", { value: "Germany" }, "Germany"),
        React.createElement("option", { value: "Ghana" }, "Ghana"),
        React.createElement("option", { value: "Gibraltar" }, "Gibraltar"),
        React.createElement("option", { value: "Greece" }, "Greece"),
        React.createElement("option", { value: "Greenland" }, "Greenland"),
        React.createElement("option", { value: "Grenada" }, "Grenada"),
        React.createElement("option", { value: "Guadeloupe" }, "Guadeloupe"),
        React.createElement("option", { value: "Guam" }, "Guam"),
        React.createElement("option", { value: "Guatemala" }, "Guatemala"),
        React.createElement("option", { value: "Guernsey" }, "Guernsey"),
        React.createElement("option", { value: "Guinea" }, "Guinea"),
        React.createElement("option", { value: "Guinea-Bissau" }, "Guinea-Bissau"),
        React.createElement("option", { value: "Guyana" }, "Guyana"),
        React.createElement("option", { value: "Haiti" }, "Haiti"),
        React.createElement("option", { value: "Heard and McDonald Islands" }, "Heard and McDonald Islands"),
        React.createElement("option", { value: "Holy See (Vatican City State)" }, "Holy See (Vatican City State)"),
        React.createElement("option", { value: "Honduras" }, "Honduras"),
        React.createElement("option", { value: "Hong Kong" }, "Hong Kong"),
        React.createElement("option", { value: "Hungary" }, "Hungary"),
        React.createElement("option", { value: "Iceland" }, "Iceland"),
        React.createElement("option", { value: "India" }, "India"),
        React.createElement("option", { value: "Indonesia" }, "Indonesia"),
        React.createElement("option", { value: "Iran, Islamic Republic of" }, "Iran, Islamic Republic of"),
        React.createElement("option", { value: "Iraq" }, "Iraq"),
        React.createElement("option", { value: "Ireland" }, "Ireland"),
        React.createElement("option", { value: "Isle of Man" }, "Isle of Man"),
        React.createElement("option", { value: "Israel" }, "Israel"),
        React.createElement("option", { value: "Italy" }, "Italy"),
        React.createElement("option", { value: "Jamaica" }, "Jamaica"),
        React.createElement("option", { value: "Japan" }, "Japan"),
        React.createElement("option", { value: "Jersey" }, "Jersey"),
        React.createElement("option", { value: "Jordan" }, "Jordan"),
        React.createElement("option", { value: "Kazakhstan" }, "Kazakhstan"),
        React.createElement("option", { value: "Kenya" }, "Kenya"),
        React.createElement("option", { value: "Kiribati" }, "Kiribati"),
        React.createElement("option", { value: "Korea, Democratic People's Republic of" }, "Korea, Democratic People's Republic of"),
        React.createElement("option", { value: "Korea, Republic of" }, "Korea, Republic of"),
        React.createElement("option", { value: "Kuwait" }, "Kuwait"),
        React.createElement("option", { value: "Kyrgyzstan" }, "Kyrgyzstan"),
        React.createElement("option", { value: "Lao People's Democratic Republic" }, "Lao People's Democratic Republic"),
        React.createElement("option", { value: "Latvia" }, "Latvia"),
        React.createElement("option", { value: "Lebanon" }, "Lebanon"),
        React.createElement("option", { value: "Lesotho" }, "Lesotho"),
        React.createElement("option", { value: "Liberia" }, "Liberia"),
        React.createElement("option", { value: "Libyan Arab Jamahiriya" }, "Libyan Arab Jamahiriya"),
        React.createElement("option", { value: "Liechtenstein" }, "Liechtenstein"),
        React.createElement("option", { value: "Lithuania" }, "Lithuania"),
        React.createElement("option", { value: "Luxembourg" }, "Luxembourg"),
        React.createElement("option", { value: "Macao" }, "Macao"),
        React.createElement("option", { value: "Macedonia, The Former Yugoslav Republic Of" }, "Macedonia, The Former Yugoslav Republic Of"),
        React.createElement("option", { value: "Madagascar" }, "Madagascar"),
        React.createElement("option", { value: "Malawi" }, "Malawi"),
        React.createElement("option", { value: "Malaysia" }, "Malaysia"),
        React.createElement("option", { value: "Maldives" }, "Maldives"),
        React.createElement("option", { value: "Mali" }, "Mali"),
        React.createElement("option", { value: "Malta" }, "Malta"),
        React.createElement("option", { value: "Marshall Islands" }, "Marshall Islands"),
        React.createElement("option", { value: "Martinique" }, "Martinique"),
        React.createElement("option", { value: "Mauritania" }, "Mauritania"),
        React.createElement("option", { value: "Mauritius" }, "Mauritius"),
        React.createElement("option", { value: "Mayotte" }, "Mayotte"),
        React.createElement("option", { value: "Mexico" }, "Mexico"),
        React.createElement("option", { value: "Micronesia, Federated States of" }, "Micronesia, Federated States of"),
        React.createElement("option", { value: "Moldova, Republic of" }, "Moldova, Republic of"),
        React.createElement("option", { value: "Monaco" }, "Monaco"),
        React.createElement("option", { value: "Mongolia" }, "Mongolia"),
        React.createElement("option", { value: "Montenegro" }, "Montenegro"),
        React.createElement("option", { value: "Montserrat" }, "Montserrat"),
        React.createElement("option", { value: "Morocco" }, "Morocco"),
        React.createElement("option", { value: "Mozambique" }, "Mozambique"),
        React.createElement("option", { value: "Myanmar" }, "Myanmar"),
        React.createElement("option", { value: "Namibia" }, "Namibia"),
        React.createElement("option", { value: "Nauru" }, "Nauru"),
        React.createElement("option", { value: "Nepal" }, "Nepal"),
        React.createElement("option", { value: "Netherlands" }, "Netherlands"),
        React.createElement("option", { value: "Netherlands Antilles" }, "Netherlands Antilles"),
        React.createElement("option", { value: "New Caledonia" }, "New Caledonia"),
        React.createElement("option", { value: "New Zealand" }, "New Zealand"),
        React.createElement("option", { value: "Nicaragua" }, "Nicaragua"),
        React.createElement("option", { value: "Niger" }, "Niger"),
        React.createElement("option", { value: "Nigeria" }, "Nigeria"),
        React.createElement("option", { value: "Niue" }, "Niue"),
        React.createElement("option", { value: "Norfolk Island" }, "Norfolk Island"),
        React.createElement("option", { value: "Northern Mariana Islands" }, "Northern Mariana Islands"),
        React.createElement("option", { value: "Norway" }, "Norway"),
        React.createElement("option", { value: "Oman" }, "Oman"),
        React.createElement("option", { value: "Pakistan" }, "Pakistan"),
        React.createElement("option", { value: "Palau" }, "Palau"),
        React.createElement("option", { value: "Palestinian Territory, Occupied" }, "Palestinian Territory, Occupied"),
        React.createElement("option", { value: "Panama" }, "Panama"),
        React.createElement("option", { value: "Papua New Guinea" }, "Papua New Guinea"),
        React.createElement("option", { value: "Paraguay" }, "Paraguay"),
        React.createElement("option", { value: "Peru" }, "Peru"),
        React.createElement("option", { value: "Philippines" }, "Philippines"),
        React.createElement("option", { value: "Pitcairn" }, "Pitcairn"),
        React.createElement("option", { value: "Poland" }, "Poland"),
        React.createElement("option", { value: "Portugal" }, "Portugal"),
        React.createElement("option", { value: "Puerto Rico" }, "Puerto Rico"),
        React.createElement("option", { value: "Qatar" }, "Qatar"),
        React.createElement("option", { value: "Reunion" }, "Reunion"),
        React.createElement("option", { value: "Romania" }, "Romania"),
        React.createElement("option", { value: "Russian Federation" }, "Russian Federation"),
        React.createElement("option", { value: "Rwanda" }, "Rwanda"),
        React.createElement("option", { value: "Saint Barthelemy" }, "Saint Barthelemy"),
        React.createElement("option", { value: "Saint Helena" }, "Saint Helena"),
        React.createElement("option", { value: "Saint Kitts and Nevis" }, "Saint Kitts and Nevis"),
        React.createElement("option", { value: "Saint Lucia" }, "Saint Lucia"),
        React.createElement("option", { value: "Saint Pierre and Miquelon" }, "Saint Pierre and Miquelon"),
        React.createElement("option", { value: "Saint Vincent and the Grenadines" }, "Saint Vincent and the Grenadines"),
        React.createElement("option", { value: "Samoa" }, "Samoa"),
        React.createElement("option", { value: "San Marino" }, "San Marino"),
        React.createElement("option", { value: "Sao Tome and Principe" }, "Sao Tome and Principe"),
        React.createElement("option", { value: "Saudi Arabia" }, "Saudi Arabia"),
        React.createElement("option", { value: "Senegal" }, "Senegal"),
        React.createElement("option", { value: "Serbia" }, "Serbia"),
        React.createElement("option", { value: "Seychelles" }, "Seychelles"),
        React.createElement("option", { value: "Sierra Leone" }, "Sierra Leone"),
        React.createElement("option", { value: "Singapore" }, "Singapore"),
        React.createElement("option", { value: "Slovakia" }, "Slovakia"),
        React.createElement("option", { value: "Slovenia" }, "Slovenia"),
        React.createElement("option", { value: "Solomon Islands" }, "Solomon Islands"),
        React.createElement("option", { value: "Somalia" }, "Somalia"),
        React.createElement("option", { value: "South Africa" }, "South Africa"),
        React.createElement("option", { value: "South Georgia and the South Sandwich Islands" }, "South Georgia and the South Sandwich Islands"),
        React.createElement("option", { value: "Spain" }, "Spain"),
        React.createElement("option", { value: "Sri Lanka" }, "Sri Lanka"),
        React.createElement("option", { value: "Sudan" }, "Sudan"),
        React.createElement("option", { value: "Suriname" }, "Suriname"),
        React.createElement("option", { value: "Svalbard and Jan Mayen" }, "Svalbard and Jan Mayen"),
        React.createElement("option", { value: "Swaziland" }, "Swaziland"),
        React.createElement("option", { value: "Sweden" }, "Sweden"),
        React.createElement("option", { value: "Switzerland" }, "Switzerland"),
        React.createElement("option", { value: "Syrian Arab Republic" }, "Syrian Arab Republic"),
        React.createElement("option", { value: "Taiwan, Province of China" }, "Taiwan, Province of China"),
        React.createElement("option", { value: "Tajikistan" }, "Tajikistan"),
        React.createElement("option", { value: "Tanzania, United Republic of" }, "Tanzania, United Republic of"),
        React.createElement("option", { value: "Thailand" }, "Thailand"),
        React.createElement("option", { value: "Timor-Leste" }, "Timor-Leste"),
        React.createElement("option", { value: "Togo" }, "Togo"),
        React.createElement("option", { value: "Tokelau" }, "Tokelau"),
        React.createElement("option", { value: "Tonga" }, "Tonga"),
        React.createElement("option", { value: "Trinidad and Tobago" }, "Trinidad and Tobago"),
        React.createElement("option", { value: "Tunisia" }, "Tunisia"),
        React.createElement("option", { value: "Turkey" }, "Turkey"),
        React.createElement("option", { value: "Turkmenistan" }, "Turkmenistan"),
        React.createElement("option", { value: "Turks and Caicos Islands" }, "Turks and Caicos Islands"),
        React.createElement("option", { value: "Tuvalu" }, "Tuvalu"),
        React.createElement("option", { value: "Uganda" }, "Uganda"),
        React.createElement("option", { value: "Ukraine" }, "Ukraine"),
        React.createElement("option", { value: "United Arab Emirates" }, "United Arab Emirates"),
        React.createElement("option", { value: "United Kingdom" }, "United Kingdom"),
        React.createElement("option", { value: "United States" }, "United States"),
        React.createElement("option", { value: "United States Minor Outlying Islands" }, "United States Minor Outlying Islands"),
        React.createElement("option", { value: "Uruguay" }, "Uruguay"),
        React.createElement("option", { value: "Uzbekistan" }, "Uzbekistan"),
        React.createElement("option", { value: "Vanuatu" }, "Vanuatu"),
        React.createElement("option", { value: "Venezuela" }, "Venezuela"),
        React.createElement("option", { value: "Viet Nam" }, "Viet Nam"),
        React.createElement("option", { value: "Virgin Islands, British" }, "Virgin Islands, British"),
        React.createElement("option", { value: "Virgin Islands, U.S." }, "Virgin Islands, U.S."),
        React.createElement("option", { value: "Wallis and Futuna" }, "Wallis and Futuna"),
        React.createElement("option", { value: "Western Sahara" }, "Western Sahara"),
        React.createElement("option", { value: "Yemen" }, "Yemen"),
        React.createElement("option", { value: "Zambia" }, "Zambia"),
        React.createElement("option", { value: "Zimbabwe" }, "Zimbabwe"))));
